import { Directive, signal } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Observable } from 'rxjs';

@Directive()
export abstract class FormFieldControl<T> implements ControlValueAccessor {
  abstract get value(): T | null;
  abstract set value(val: T | null);

  readonly stateChanges?: Observable<void>;

  readonly id?: string;

  readonly focused = signal(false);

  readonly errorState = signal(false);

  readonly isDisabled = signal(false);

  abstract get empty(): boolean;

  abstract setDescribedByIds(ids: string[]): void;

  abstract onContainerClick(event: MouseEvent): void;

  abstract writeValue(obj: any): void;
  abstract registerOnChange(fn: any): void;
  abstract registerOnTouched(fn: any): void;
  abstract setDisabledState?(isDisabled: boolean): void;
}
